import React, { useEffect, useState,useCallback } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
import Sidebar from '../components/Sidebar';
import base_url from '../config/Config';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import PageLoader from '../components/PageLoader';

const AllEmployee = () => {
    const [admins, setAdmins] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const token = Cookies.get('authToken');
    const navigate = useNavigate();
    const [permissions, setPermissions] = useState([]);

  
    //    Pemisiion privillages atart 
    
         useEffect(() => {
                const adminId = localStorage.getItem('adminId') || '';
                axios.get(`${base_url}/api/auth/tabs/${adminId}`)
                    .then(res => setPermissions(res.data || []))
                    .catch(() => setPermissions([]))
                    .finally(() => setPageLoading(false));
            }, []);
        
            // Permission check helper
            const hasPermission = useCallback((tabName, action) => {
                const tab = permissions.find(t => t.tabName === tabName);
                if (!tab) return false;
                switch (action) {
                    case 'view': return !!tab.canView;
                    case 'edit': return !!tab.canEdit;
                    case 'download': return !!tab.canDelete; // using canDelete for download
                    default: return false;
                }
            }, [permissions]);
    //    Pemisiion privillages end


    useEffect(() => {
        if (token) {
                    if (!hasPermission('All Eployee', 'view')) return;
            axios.get(`${base_url}/api/admin/list`, {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
                .then(res => setAdmins(res.data))
                .catch(err => console.error('List Error:', err));
        }
    }, [token, hasPermission]); // ✅ Dependency fixed

    if (pageLoading) return <PageLoader text="Loading..." />;

    if (!hasPermission('All Eployee', 'view')) {
        return (
            <div className="text-center mt-5">
                <h3>Access Denied</h3>
            </div>
        );
    }

    return (
        <>
            <div className='overviewsaa'>
                <h4>Admin Details</h4>
            </div>

            <div className='navigationss mb-5'>
                <Navigation />
            </div>

            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>

                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms text-center'>
                            <div className='text-end mb-3'>
                                <button
                                    className='btn btn-primary'
                                    hasPermission={hasPermission('All Eployee', 'edit') ? false : true} // Disable if no edit permission
                                    style={{ backgroundColor: hasPermission('Employee', 'edit') ? '#007bff' : 'grey', borderColor: hasPermission('Employee', 'edit') ? '#007bff' : 'grey', cursor: hasPermission('Employee', 'edit') ? 'pointer' : 'not-allowed' }}
                                    onClick={() => navigate('/employee/AddEmployee')}
                                >
                                    Add Employee
                                </button>
                            </div>

                            <div className='allcustomer table-responsive table-striped mt-3'>
                                { pageLoading ? <PageLoader text="Loading..." /> : admins.length > 0  ? (
                                    <table className='table text-center styled-table' >
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Admin_ID</th>
                                                <th>Password</th>
                                                <th>Create_Date</th>
                                                <th>Employee_ID</th>
                                                <th>Employee_Name</th>
                                                <th>Branch_Name</th>
                                                <th>Is_Active</th>
                                                <th>Update_Date</th>
                                                <th>Actions</th> {/* ✅ View column */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[...admins]
                                                .sort((a, b) => a.id - b.id) // 🔁 Sort by ID in ascending order
                                                .map(admin => (
                                                    <tr key={admin.id}>
                                                        <td>{admin.id}</td>
                                                        <td>{admin.adminId}</td>
                                                        <td>{admin.adminPassword}</td>
                                                        <td>{new Date(admin.createDate).toLocaleDateString()}</td>
                                                        <td>US{admin.employeeId}</td>
                                                        <td>{admin.employeeName}</td>
                                                        <td>{admin.branchName}</td>
                                                        <td>{admin.isActive ? 'Yes' : 'No'}</td>
                                                        <td>{new Date(admin.updateDate).toLocaleDateString()}</td>
                                                        <td>
                                                            <button
                                                                className="btn btn-sm btn-info"
                                                                style={{ backgroundColor: '#17a2b8', borderColor: '#17a2b8', cursor: 'pointer' }}
                                                                hasPermission={hasPermission('All Eployee', 'view') ? false : true} // Disable if no view permission
                                                                onClick={() => navigate(`/employee/ViewEmployee?id=${admin.id}`)}
                                                            >
                                                                View
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}

                                        </tbody>
                                    </table>
                                ) : (
                                    <p>No Admin Records Found</p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AllEmployee;
